export default __webpack_public_path__ + "static/media/1.494c5ccb.jpg";